import React, { Fragment } from "react";
import YellowConfirm from "./YellowConfirm";
import Table from "./Table";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { connect } from "react-redux";
import { getAllApartments, setPrinted } from "../reducers/apartments";

import { printOrder, printChecklist } from "../services/createPdf";
import moment from "moment";

const textAllert = [
  {
    text: "Attenzione",
    fontSize: 32,
    paddingBottom: "3vh",
  },
  {
    text:
      "L'operazione stamperà tutti gli ordini nuovi e rimuoverà le icone di notifica degli appuntamenti.",
    fontSize: 18,
  },
  {
    text: "Confermi?",
    fontSize: 18,
    paddingBottom: "3vh",
  },
];
const table = [{}, {}, {}, {}, {}, {}, {}];
const style = {
  paddingTop: "3vh",
  paddingLeft: "2vw",
  paddingBottom: "2vh",
};
class TableSection extends React.Component {
  state = {
    openStampa1: false,
    openStampa2: false,
    inProp: false,
  };

  formatDate = (date, toSort) => moment(date).format(toSort ? "YYYY/MM/DD" : "DD/MM/YYYY");

  formatHour = (date) => moment(date).format("HH:mm");

  getServiceDate = (ser, toSort) => {
    return this.formatDate(
      ser.data && ser.data.length > 0
        ? ser.data[0].data_prenotazione ||
            ser.data[0].data_consegna_prevista ||
            ser.data[0].orario ||
            ser.createdAt
        : ser.createdAt,
      toSort
    );
  };

  getHourRange = (data, durata) =>
    `${this.formatHour(data)} ${
      durata ? "- " + this.formatHour(moment(data).add(durata, "minutes")) : ""
    }`;

  getServiceHour = (ser) => {
    console.log("ser", ser);
    return ser.data && ser.data.length > 0
      ? !!ser.data[0].ora_consegna_prevista
        ? ser.data[0].ora_consegna_prevista
        : !!ser.data[0].orario || !!ser.data[0].data_prenotazione
        ? this.getHourRange(ser.data[0].orario || ser.data[0].data_prenotazione, ser.data[0].durata)
        : ""
      : "";
  };

  renderCode = (ser, apartment) => {
    return `${apartment.split(" ").reverse()[0]}${ser.tipologia.slice(0, 2).toUpperCase()}${
      ser.id
    }`;
  };

  renderRepetition = (type) => {
    switch (type) {
      case "mai":
        return "Singola";
      case "ogni_giorno":
        return "Giornaliera";
      case "ogni_settimana":
        return "Settimanale";
      case "ogni_due_settimane":
        return "Ogni due settimane";
      case "ogni_mese":
        return "Mensile";
      default:
        return "Singola";
    }
  };

  getServiceDescription = (obj) => {
    let cleaned = [...obj.data];
    if (obj.data.find((o) => !!o.tipologia || !!o.numero_pacco || o.ripetizione)) {
      cleaned = cleaned.map((ser) => {
        const s = {};

        if (!!ser.numero) {
          s.numero = ser.numero + "x";
        }
        if (!!ser.tipologia) {
          s.tipologia = ser.tipologia;
        }
        if (!!ser.mittente) {
          s.mittente = ser.mittente;
        }
        if (!!ser.numero_pacco) {
          s.numero_pacco = ser.numero_pacco;
        }
        if (!!ser.ripetizione) {
          s.ripetizione = this.renderRepetition(ser.ripetizione) + ",";
        }
        if (!!ser.giorno_ripetizione) {
          s.giorno_ripetizione = ser.giorno_ripetizione + " alle";
        }
        if (!!ser.ora_ripetizione) {
          s.ora_ripetizione = ser.ora_ripetizione;
        }
        if (!!ser.descrizione) {
          s.descrizione = ser.descrizione;
        }
        return s;
      });
    } else {
      return "1x " + obj.tipologia;
    }
    return cleaned.reduce((acc, curr, i) => {
      const arr = Object.entries(curr);
      return acc + arr.map((arr) => arr[1]).join(" ") + (i === cleaned.length - 1 ? "" : ", ");
    }, "");
  };

  confirm = async () => {
    if (this.props.servizi.length > 0) {
      const ordersNotPrinted = this.props.servizi
        .filter((ser) => !ser.evaso)
        .filter((ser) => !ser.printed)
        .map((ser) => {
          return {
            ...ser,
            apartment: this.props.apartmentName,
            code: this.renderCode(ser, this.props.apartmentName),
            dateToPrint: this.getServiceDate(ser, false),
            hourToPrint: this.getServiceHour(ser),
            descrizione: this.getServiceDescription(ser),
          };
        });
      console.log('orders', ordersNotPrinted)
      if (ordersNotPrinted.length > 0) {
        printChecklist(ordersNotPrinted);
        await Promise.all(
          ordersNotPrinted.map(async (o) => {
            return await this.props.setPrinted(o.id);
          })
        );
      }
    }

    this.setState({ openStampa2: true, openStampa1: true });
    setTimeout(() => {
      this.setState({ openStampa2: false, openStampa1: false });
    }, 2000);
  };

  render() {
    console.log(this.props);
    // console.log(this.props.servizio)
    // console.log(this.props.apartment);
    return (
      <Fragment>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {this.props.servizi
              .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))
              .map((servizio, i) => (
                <div key={`table_servizio_${i}`} style={style}>
                  <Table
                    scope={this.props.scope}
                    servizio={servizio}
                    apartmentName={this.props.apartmentName}
                  />
                </div>
              ))}
          </div>
          <div style={style}>
            <div></div>
            <YellowConfirm
              text={"Stampa"}
              action={() => this.setState({ openStampa1: !this.state.openStampa1 })}
              padding={"1.5vh"}
              width={"10vw"}
            />
          </div>
          <TransitionGroup>
            <CSSTransition
              classNames={"fade"}
              // key={}
              timeout={{ enter: 500, exit: 500 }}
              in={this.state.inProp}
              unmountOnExit={true}
            >
              {this.state.openStampa1 ? (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: window.innerHeight,
                    width: window.innerWidth,
                    backgroundColor: "rgba(0,0,0,0.6)",
                    zIndex: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      width: "40vw",
                      height: "40vh",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      zIndex: 600,
                    }}
                  >
                    {textAllert.map((textAllert, i) => (
                      <div
                        key={`text_alert_${i}`}
                        style={{
                          fontSize: textAllert.fontSize,
                          paddingBottom: textAllert.paddingBottom,
                          paddingLeft: "4vw",
                          paddingRight: "4vw",
                        }}
                      >
                        {textAllert.text}
                      </div>
                    ))}
                    <YellowConfirm
                      text={"Conferma"}
                      action={this.confirm}
                      padding={"1.5vh"}
                      width={"8vw"}
                    />
                  </div>
                </div>
              ) : (
                <div style={{ display: "none" }}>hidden</div>
              )}
            </CSSTransition>
          </TransitionGroup>
          <TransitionGroup>
            <CSSTransition
              classNames={"fade"}
              // key={Math.random()}
              timeout={{ enter: 500, exit: 500 }}
              in={this.state.inProp}
              unmountOnExit={true}
            >
              {this.state.openStampa2 ? (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: window.innerHeight,
                    width: window.innerWidth,
                    backgroundColor: "rgba(0,0,0,0.6)",
                    zIndex: 100,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      width: "40vw",
                      height: "40vh",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      zIndex: 200,
                    }}
                  >
                    <div style={{ color: "#645B40", fontSize: 36 }}>Operazione Completata</div>
                  </div>
                </div>
              ) : (
                <div style={{ display: "none" }}>hidden</div>
              )}
            </CSSTransition>
          </TransitionGroup>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  apartments: state.apartments.data,
  apartment: state.apartments.singleApartment.user,
  servizi: state.apartments.singleApartment.user.servizi.filter(
    (servizi) => servizi.tipologia.toLowerCase() == (ownProps.scope && ownProps.scope.toLowerCase())
  ),
  loading: state.apartments.loading,
  error: state.apartments.error,
});

export default connect(mapStateToProps, { getAllApartments, setPrinted })(TableSection);

// filtro data ls
// const lsKeyName =
//   this.props.apartmentName.replaceAll(" ", "").toLowerCase() +
//   "-" +
//   this.props.servizi[0].tipologia.toLowerCase() +
//   "-" +
//   "print_time";
// const lsLastPrinted = localStorage.getItem(lsKeyName);

// let lastPrinted;
// if (lsLastPrinted) {
//   lastPrinted = new Date(lsLastPrinted);
// } else {
//   lastPrinted = new Date("2021-01-01");
// }
// console.log("last print", lastPrinted);

// orders: this.props.servizi.filter((ser) => new Date(ser.createdAt) > lastPrinted),

// localStorage.setItem(lsKeyName, new Date().toISOString());
